import './otel';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Provider } from 'react-redux';
import store from './redux/store/index.ts';
import { ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import { BrowserRouter } from 'react-router-dom';
import { blue } from '@ant-design/colors';

import * as Sentry from '@sentry/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { env } from './env';

if (env.VITE_ENVIRONMENT) {
	Sentry.init({
		environment: env.VITE_ENVIRONMENT,
		dsn: 'https://7496b02daec2675936d16cf0e5d0570f@o307418.ingest.sentry.io/4506158153400320',
		// @sentry/react's default integrations already capture:
		//   - Unhandled JS errors (window.onerror)
		//   - Unhandled promise rejections
		//   - Console errors
		integrations: [
			new Sentry.Replay(),
		],
		// Performance Monitoring
		tracesSampleRate: 0,
		// Session Replay
		replaysSessionSampleRate: 0.1, // 10% of regular sessions
		replaysOnErrorSampleRate: 1.0, // 100% of sessions where errors occur
	});
}

function SentryFallback() {
	return (
		<div style={{ padding: 40, textAlign: 'center', fontFamily: 'Inter, sans-serif' }}>
			<h2>Something went wrong</h2>
			<p>An unexpected error occurred. Please refresh the page.</p>
			<button
				onClick={() => window.location.reload()}
				style={{
					padding: '8px 16px',
					background: '#1c2a38',
					color: '#fff',
					border: 'none',
					borderRadius: 4,
					cursor: 'pointer',
				}}
			>
				Refresh
			</button>
		</div>
	);
}

export const THEME = {
	token: {
		colorPrimary: '#1c2a38',
		colorLink: blue.primary,
		colorLinkHover: blue[3],
		colorPrimaryBg: '#e0e6ec',
		colorPrimaryBgHover: '#ecf0f4',
		fontFamily: 'Inter',
		fontWeightStrong: 700,
		borderRadius: 4,
		colorBorder: '#cbcbcb',
		colorBorderSecondary: '#eaeaea',
	},
	components: {
		Table: {
			headerBg: '#ffffff',
		},
	},
};

ReactDOM.createRoot(document.getElementById('root')!).render(
	<Sentry.ErrorBoundary fallback={<SentryFallback />}>
		<Provider store={store}>
			<BrowserRouter>
				<GoogleOAuthProvider clientId={env.VITE_GOOGLE_CLIENT_ID as string}>
					<React.StrictMode>
						<StyleProvider hashPriority="high">
							<ConfigProvider theme={THEME}>
								<App />
							</ConfigProvider>
						</StyleProvider>
					</React.StrictMode>
				</GoogleOAuthProvider>
			</BrowserRouter>
		</Provider>
	</Sentry.ErrorBoundary>
);
